import { hourTimeOptions } from './optionsConst';
import { getActualLang } from '../device/getActualLang';
import { isValidDateInIso } from '../datetime/isValidDateInIso';

export const hourTime = (dateInIso) =>
  (isValidDateInIso(dateInIso))
  ? new Intl.DateTimeFormat(getActualLang(), hourTimeOptions).format(new Date(dateInIso))
  : "";
